// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as StyleUtil from "../../domain/common/StyleUtil.bs.js";
import * as RnrAssetManager from "../../assets/RnrAssetManager.bs.js";
import * as BackButtonComponent from "../BackButtonComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

var orderFullfillmentLogo = RnrAssetManager.getImage("order_fulfillment_icon.svg");

function getTotalClaimedOrderFulfillmentPoints(viewModel) {
  var rewardCategoryAggVM = List.find((function (rewardCategoryAggVM) {
          var match = rewardCategoryAggVM.name;
          return match >= 2;
        }), viewModel.cycleAgg.categoryAggList);
  return String(rewardCategoryAggVM.points);
}

function getDailyMaxSlabPoints(viewModel) {
  var lst = List.sort(Caml_obj.caml_compare, viewModel.computerDetails.orderFulfillmentComputerDetails.slabs);
  return List.nth(lst, List.length(lst) - 1 | 0).points;
}

function getSlabs(viewModel, content) {
  var param = List.partition((function (slab) {
          return slab.points < getDailyMaxSlabPoints(viewModel);
        }), viewModel.computerDetails.orderFulfillmentComputerDetails.slabs);
  return ReasonReactUtils$Catalyst.listToReactArray(List.map((function (slab) {
                    var orderCount = slab.orderCount;
                    return React.createElement("div", {
                                className: "flex-row"
                              }, React.createElement("div", {
                                    className: "flex-col"
                                  }, slab.points === getDailyMaxSlabPoints(viewModel) ? Curry._1(content.getLastSlabText, String(orderCount)) : String(orderCount)), React.createElement("div", {
                                    className: "flex-col"
                                  }, String(slab.points)));
                  }), List.sort(Caml_obj.caml_compare, List.append(param[0], {
                          hd: List.nth(param[1], 0),
                          tl: /* [] */0
                        }))));
}

function RnrOrderFulfilmentRewardComponent(Props) {
  var viewModel = Props.viewModel;
  var content = Props.content;
  return React.createElement("div", {
              className: "category-description"
            }, React.createElement("div", {
                  className: "category-description__header"
                }, React.createElement(BackButtonComponent.make, {
                      className: "category-description__backArrow",
                      text: "x"
                    }), React.createElement("div", {
                      className: "category-description__header-name"
                    }, content.category.orderFulfillment)), React.createElement("div", {
                  className: StyleUtil.getColor(/* OrderFulfillment */2, "category-description") + " category-description__banner"
                }, React.createElement("img", {
                      className: "category-description__banner-img",
                      src: orderFullfillmentLogo
                    }), React.createElement("div", {
                      className: "category-description__banner-name"
                    }, content.category.orderFulfillment), React.createElement("div", {
                      className: "category-description__banner-text"
                    }, Curry._1(content.getOrderFullfillmentRewardsDetailsText, getTotalClaimedOrderFulfillmentPoints(viewModel)))), React.createElement("div", {
                  className: "category-description__body"
                }, React.createElement("div", {
                      className: "category-description__body-guidelines"
                    }, content.orderFulfillmentDetails.details1), React.createElement("div", {
                      className: "category-description__body-details"
                    }, React.createElement("div", {
                          className: "u-margin-bottom-large"
                        }, content.orderFulfillmentDetails.details2), React.createElement("ul", {
                          className: "category-description__body-guidelines-list"
                        }, React.createElement("li", {
                              className: "category-description__body-guidelines-row"
                            }, content.orderFulfillmentDetails.tip1), React.createElement("li", {
                              className: "category-description__body-guidelines-row"
                            }, Curry._1(content.getOrderFullfillmentDailyMaxPointsTip, String(getDailyMaxSlabPoints(viewModel)))), React.createElement("li", {
                              className: "category-description__body-guidelines-row"
                            }, content.orderFulfillmentDetails.tip2))), React.createElement("div", {
                      className: "category-description__body-guidelines"
                    }, content.orderFulfillmentDetails.slabTableText), React.createElement("section", {
                      className: "table-layout"
                    }, React.createElement("header", {
                          className: "flex-row table-layout-headers"
                        }, React.createElement("div", {
                              className: "flex-col"
                            }, content.orderFulfillmentDetails.slabTableCol1), React.createElement("div", {
                              className: "flex-col"
                            }, content.orderFulfillmentDetails.slabTableCol2)), getSlabs(viewModel, content))));
}

var make = RnrOrderFulfilmentRewardComponent;

export {
  orderFullfillmentLogo ,
  getTotalClaimedOrderFulfillmentPoints ,
  getDailyMaxSlabPoints ,
  getSlabs ,
  make ,
  
}
/* orderFullfillmentLogo Not a pure module */
